import React from 'react';
import { Table } from 'antd';

class Download extends React.Component {

    constructor() {
        super();
        this.state = {"total":5,"rows":[{"id":15,"name":"十间鱼公众号","description":"A4物联网云打印机的windows驱动","status":1,"softwarePackage":"http://sjy-soft.oss-cn-hangzhou.aliyuncs.com/download/file/十间鱼公众号.jpg","type":0,"system":"windows","version":"V3.04","size":"30.98KB"},{"id":16,"name":"十间鱼寄件端","description":"A4物联网云打印机的windows驱动","status":1,"softwarePackage":"http://sjy-soft.oss-cn-hangzhou.aliyuncs.com/download/file/十间鱼寄件端.jpg","type":0,"system":"windows","version":"V3.04","size":"30.98KB"},{"id":17,"name":"十间鱼寄件端","description":"A4物联网云打印机的windows驱动","status":1,"softwarePackage":"http://sjy-soft.oss-cn-hangzhou.aliyuncs.com/download/file/十间鱼寄件端2.jpg","type":0,"system":"windows","version":"V3.04","size":"30.98KB"},{"id":18,"name":"十间鱼安卓收件端","description":"A4物联网云打印机的windows驱动","status":1,"softwarePackage":"http://sjy-soft.oss-cn-hangzhou.aliyuncs.com/download/file/十间鱼安卓收件端.png","type":0,"system":"windows","version":"V3.04","size":""}],"data":[{"id":14,"name":"A4物联网云打印机","description":"A4物联网云打印机的windows驱动","status":1,"softwarePackage":"http://sjy-soft.oss-cn-hangzhou.aliyuncs.com/download/file/十间鱼官网产中中心产品文案(1).docx","type":1,"system":"windows","version":"V3.04","size":"30.98KB"}],"backUrl":null,"errCode":200,"errMsg":"查询软件/驱动列表信息成功","token":null,"data2":null,"data3":null,"data4":null,"data5":null,"success":true};
    }

    downloadFile(content, filename) {
        var a = document.createElement('a')
        var blob = new Blob([content])
        var url = window.URL.createObjectURL(blob)
        a.href = url
        a.download = filename
        a.click()
        window.URL.revokeObjectURL(url)
    }

    download(url,filename){
        let t = this;
        
        this.ajax(url, function(xhr) {
            filename = filename + '.' + url.replace(/(.*\.)/, '') // 自定义文件名+后缀
            t.downloadFile(xhr.response, filename)
        }, {
            responseType: 'blob'
        })
    }

    ajax(url, callback, options) {
        window.URL = window.URL || window.webkitURL
        var xhr = new XMLHttpRequest()
        xhr.open('get', url, true)
        if (options.responseType) {
            xhr.responseType = options.responseType
        }
        xhr.onreadystatechange = function() {
            if (xhr.readyState === 4 && xhr.status === 200) {
                callback(xhr)
            }
        }
        xhr.send()
    }


    render() {

        const columns = [
            {
              title: '打印机名称',
              dataIndex: 'name',
              key: 'name',
            },
            {
              title: '描述',
              dataIndex: 'description',
              key: 'desc',
            },
            {
              title: '系统',
              dataIndex: 'system',
              key: 'system',
            },
            {
              title: '版本',
              dataIndex: 'version',
              key: 'version',
            },
            {
              title: '文件大小',
              dataIndex: 'size',
              key: 'size',
            },
            {
              title: '操作',
              dataIndex: 'action',
              key: 'action',
              render:(text,record) => {
                return <a onClick={ this.download.bind(this,record.softwarePackage,record.name)}>下载</a>
              }
            },
        ];

        return <div>
        <p style={{lineHeight:"40px",fontSize:'20px',borderLeft:'3px solid #386EB1',paddingLeft:'20px'}}>软件下载</p>
        <ul style={{display:'flex',justifyContent:'space-between'}}>
            {
                this.state.rows.map((item,index) => {
                    return  <li style={{width:'150px',margin:'30px',textAlign:'center'}}>
                        <img src={item.softwarePackage} alt=""/>
                        <p style={{textAlign:'center'}}>{item.name}</p>
                    </li>
                })
            }
        </ul>
        <p style={{lineHeight:"40px",fontSize:'20px',borderLeft:'3px solid #386EB1',paddingLeft:'20px'}}>工具下载</p>
        <Table columns={columns} dataSource={this.state.data} bordered={true} pagination={false}/>
    </div>
    }
}

export default Download;